import { getAccountSetup } from '../actions';
import * as types from './types';

export const withdrawStudent = idSeed => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `student/withdraw/${idSeed}`,
        { idSeed }
      );

      dispatch({
        type: types.ACCOUNT_SETUP_WITHDRAW_SUCCESS,
        payload: response.data.Data,
      });
      dispatch(getAccountSetup({}));
    } catch (error) {
      dispatch({ type: types.ACCOUNT_SETUP_WITHDRAW_FAIL, payload: error });
    }
  };
};

export const clearWithdraw = () => {
  return {
    type: types.ACCOUNT_SETUP_WITHDRAW_CLEAR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/withdraw/actions.js